<div [class]="'tabs-container ' + size + (isZoomed ? ' is-zoomed' : '')">
  @for(tab of tabs; track tab?.tabName){
  <p
    class="tab"
    (click)="toggleTab(tab)"
    (keydown.enter)="toggleTab(tab)"
    [ngClass]="{ active: tab.isActive }"
    [tabIndex]="0"
    [ariaLabel]="'Go to ' + tab.tabName + ' tab'"
    aria-live="polite"
  >
    {{ tab.tabName }}
  </p>
  }
</div>
